import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=47ef1e48&scoped=true&"
import script from "./Stats.vue?vue&type=script&lang=js&"
export * from "./Stats.vue?vue&type=script&lang=js&"
import style0 from "./Stats.vue?vue&type=style&index=0&id=47ef1e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef1e48",
  null
  
)

export default component.exports